/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Bewilligtestunden1Inputs */

const de__field_bewilligtestunden1 = /** @type {(inputs: _Field_Bewilligtestunden1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bewilligte Einheiten`)
};

/**

* @param {_Field_Bewilligtestunden1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_bewilligtestunden1 = /** @type {((inputs?: _Field_Bewilligtestunden1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Bewilligtestunden1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_bewilligtestunden1(inputs)
});
export { _field_bewilligtestunden1 as "_field_bewilligteStunden" }